/** Un motivo después de dos puntos: sin el punto final y con minúscula (salvo un nombre propio como Halory o Dra. IA). */
export const motivoTxt = (m: string | null | undefined) => {
  const t = String(m || 'error').trim().replace(/\.\s*$/, '');
  return /^(Halory|Dra\.?|HUB|Meta|Mercado)\b/.test(t) || /^[A-ZÁÉÍÓÚÑ]{2,}\b/.test(t) ? t : t.charAt(0).toLowerCase() + t.slice(1);
};
